import { el, setChildren } from 'redom';

import serverInterface from 'server-interface';

import { stringToSVG } from 'utilities';

import SaveButton from 'generics/components/save-button';
import IconButton from 'generics/components/icon-button';

import editIconString from 'assets/images/edit-icon.svg?raw';

const editIcon = stringToSVG(editIconString);

class ProductViewer {

  constructor(configuration) {

    this.product = null;

    this.productId = configuration.productId;
    this.onEdit = configuration.onEdit;
    this.onNotFound = configuration.onNotFound;

    this.name = el('h5.product-name');
    this.description = el('label.product-description');
    this.price = el('label.product-price');
    this.productDetails = el('.product-details', [
      this.name,
      this.description,
      this.price
    ]);
    this.saveButton = new SaveButton({
      label: 'Buy',
      onClick() {}
    });
    this.buttonControls = el('.product-button-controls', [
      this.saveButton
    ]);

    this.el = el('.product-viewer-main', [
      this.buttonControls
    ]);

  }

  onmount() {

    this.initialize();

  }

  updateDetails() {

    const product = this.product;

    this.name.textContent = product.name;
    this.description.textContent = product.description;
    this.price.textContent = `$${product.price.unitAmount}`;

  }

  update(product) {

    this.product = product;
    this.productId = this.product._id;

    this.updateDetails();

  }

  async loadProduct() {

    try {

      setChildren(this.el, [el('ht-spinner')]);

      this.product = await serverInterface.startup.marketProducts.getMarketProductById(this.productId);

      this.saveButton.update({ label: `Buy ${this.product.name}` });

      setChildren(this.el, [this.buttonControls]);

      return true;

    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);
      this.onNotFound();

      return false;

    }

  }

  async displayProduct() {

    if (this.product === null) {
      const loaded = await this.loadProduct();
      if (loaded === false) {
        return;
      }
    }

    this.updateDetails();

  }

  async initialize() {

    await this.displayProduct();

  }

  handleEditButtonClick() {

    this.onEdit(this.product);

  }

}

export default ProductViewer;